import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import {
    getLensSourceListEnabled,
    type GetLensSourceListEnabledQuery,
    type GetLensSourceListEnabledQueryVariables,
} from "../api/queries";

export const useEnabledLensSources = () => {
    const { data, loading, error } = useQuery<GetLensSourceListEnabledQuery, GetLensSourceListEnabledQueryVariables>(
        getLensSourceListEnabled,
    );

    const sources = useMemo(() => data?.getLensSourceListEnabled?.lensSourceMap || [], [data]);

    return {
        sources,
        loading,
        error,
        isAnySourceEnabled: sources.length > 0,
    };
};
